import type { QueryClient } from "@tanstack/react-query";
import { workspaceDetailsQueryOptions } from "@api/workspace.api";
import { effectiveWorkspaceRole } from "@common/helpers/effectiveWorkspaceRole";
import { UserWorkspaceRole } from "@common/userWorkspaceRoles";

/** Whether the user is View-only in a workspace, by the rule `useActiveWorkspaceRole` applies; `false` while unresolved. */
export const getIsViewOnlyInWorkspace = async ({
    queryClient,
    userId,
    workspaceId,
}: {
    queryClient: QueryClient;
    userId: number | undefined;
    workspaceId: string;
}): Promise<boolean> => {
    if (userId === undefined) {
        return false;
    }
    try {
        const { workspace } = await queryClient.ensureQueryData({
            ...workspaceDetailsQueryOptions(workspaceId),
            revalidateIfStale: true,
        });
        const assignment = workspace.userAssignments?.find(
            (userAssignment) => userAssignment.userId === userId,
        );
        const role = effectiveWorkspaceRole({
            storedRole: assignment?.role ?? null,
            plan: workspace.plan ?? null,
        });
        return role === UserWorkspaceRole.VIEW_ONLY;
    } catch {
        return false;
    }
};
